<div
  class="rounded-2xl border p-4 shadow-sm transition-all duration-200"
  [ngClass]="{
    'bg-blue-50 border-blue-200 dark:bg-blue-900/20 dark:border-blue-800': color() === 'primary',
    'bg-sky-50 border-sky-200 dark:bg-sky-900/20 dark:border-sky-800': color() === 'info',
    'bg-green-50 border-green-200 dark:bg-green-900/20 dark:border-green-800': color() === 'success',
    'bg-amber-50 border-amber-200 dark:bg-amber-900/20 dark:border-amber-800': color() === 'warning',
    'bg-red-50 border-red-200 dark:bg-red-900/20 dark:border-red-800': color() === 'danger',
    'bg-neutral-50 border-neutral-200 dark:bg-neutral-900/50 dark:border-neutral-700': color() === 'neutral'
  }"
>
  <div class="flex gap-4 h-full">
    <!-- Esquerda: Imagem ou Ícone -->
    @if (imageUrl()) {
      <div class="shrink-0">
        <img [src]="imageUrl()" alt="Card image" class="h-12 w-12 rounded-xl object-cover" />
      </div>
    } @else if (icon()) {
      <div class="shrink-0 flex items-center justify-center h-12 w-12 rounded-xl bg-white/50 dark:bg-black/20">
         <i [innerHTML]="icon()! | feather: { width: iconSize(), height: iconSize() }"
            [ngClass]="{
              'text-neutral-600 dark:text-neutral-400': color() === 'neutral',
              'text-blue-600 dark:text-blue-400': color() === 'primary',
              'text-sky-600 dark:text-sky-400': color() === 'info',
              'text-green-600 dark:text-green-400': color() === 'success',
              'text-amber-600 dark:text-amber-400': color() === 'warning',
              'text-red-600 dark:text-red-400': color() === 'danger'
            }"></i>
      </div>
    }

    <!-- Direita: Conteúdo e Valor -->
    <div class="flex-1 min-w-0 flex flex-col justify-between">
      <div>
        @if (title() || subtitle()) {
          <div class="mb-1">
            @if (title()) {
              <h3 class="text-base font-bold truncate"
                  [ngClass]="{
                    'text-neutral-900 dark:text-white': color() === 'neutral',
                    'text-blue-900 dark:text-blue-100': color() === 'primary',
                    'text-sky-900 dark:text-sky-100': color() === 'info',
                    'text-green-900 dark:text-green-100': color() === 'success',
                    'text-amber-900 dark:text-amber-100': color() === 'warning',
                    'text-red-900 dark:text-red-100': color() === 'danger'
                  }">
                {{ title() }}
              </h3>
            }
            @if (subtitle()) {
              <p class="text-xs truncate"
                 [ngClass]="{
                    'text-neutral-500 dark:text-neutral-400': color() === 'neutral',
                    'text-blue-700/70 dark:text-blue-300/70': color() === 'primary',
                    'text-sky-700/70 dark:text-sky-300/70': color() === 'info',
                    'text-green-700/70 dark:text-green-300/70': color() === 'success',
                    'text-amber-700/70 dark:text-amber-300/70': color() === 'warning',
                    'text-red-700/70 dark:text-red-300/70': color() === 'danger'
                 }">
                {{ subtitle() }}
              </p>
            }
          </div>
        }

        <div class="text-sm mb-2"
             [ngClass]="{
                'text-neutral-700 dark:text-neutral-300': color() === 'neutral',
                'text-blue-800 dark:text-blue-200': color() === 'primary',
                'text-sky-800 dark:text-sky-200': color() === 'info',
                'text-green-800 dark:text-green-200': color() === 'success',
                'text-amber-800 dark:text-amber-200': color() === 'warning',
                'text-red-800 dark:text-red-200': color() === 'danger'
             }">
          <ng-content></ng-content>
        </div>
      </div>

      <!-- Valor (Inferior Direito) -->
      <div class="flex justify-end items-baseline gap-1"
           [ngClass]="{
              'text-neutral-900 dark:text-white': color() === 'neutral',
              'text-blue-900 dark:text-blue-50': color() === 'primary',
              'text-sky-900 dark:text-sky-50': color() === 'info',
              'text-green-900 dark:text-green-50': color() === 'success',
              'text-amber-900 dark:text-amber-50': color() === 'warning',
              'text-red-900 dark:text-red-50': color() === 'danger'
           }">
        @if (prefix()) {
          <span class="text-sm font-semibold opacity-70">{{ prefix() }}</span>
        }

        <span class="text-3xl font-extrabold tracking-tight">
          @if (isNumber() && decimalFormat()) {
            {{ value() | number: decimalFormat() }}
          } @else {
            {{ value() }}
          }
        </span>

        @if (suffix()) {
          <span class="text-sm font-semibold opacity-70">{{ suffix() }}</span>
        }
      </div>
    </div>
  </div>
</div>
